/** */
import { urls } from 'services/_url';
import { apiPost } from 'services/_http';

const base_url = `${urls.users}/demos`;

export const create = async (payload) => {
  return apiPost(`${base_url}`, payload);
};
